import { c as _c } from "react-compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useMutation } from "@tanstack/react-query";
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import type { DisplayVerifyPhoneNumberForAssessmentResultsResponse, DisplayVerifyPhoneNumberResponse, InitiatePhoneNumberVerificationRequest, VerifyPhoneNumberForAssessmentResultsRequest, VerifyPhoneNumberRequest } from "../model";
import { retrieveData } from "../../custom-fetch";
import type { ErrorType, BodyType } from "../../custom-fetch";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
export const getInitiatedPhoneNumberVerificationForAssessmentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/auth/assessments/${assessmentId}/initiate-phone-verification`;
};

/**
 * @summary Initiates the verification request for phone number verification.
 */
export const initiatedPhoneNumberVerificationForAssessment = async (assessmentId: string, initiatePhoneNumberVerificationRequest?: InitiatePhoneNumberVerificationRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getInitiatedPhoneNumberVerificationForAssessmentUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(initiatePhoneNumberVerificationRequest)
  });
};
export const getInitiatedPhoneNumberVerificationForAssessmentMutationKey = () => ["initiatedPhoneNumberVerificationForAssessment"] as const;
export const getInitiatedPhoneNumberVerificationForAssessmentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof initiatedPhoneNumberVerificationForAssessment>>, TError, InitiatedPhoneNumberVerificationForAssessmentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof initiatedPhoneNumberVerificationForAssessment>>, TError, InitiatedPhoneNumberVerificationForAssessmentMutationVariables, TContext> => {
  const mutationKey = getInitiatedPhoneNumberVerificationForAssessmentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatedPhoneNumberVerificationForAssessment>>, InitiatedPhoneNumberVerificationForAssessmentMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return initiatedPhoneNumberVerificationForAssessment(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type InitiatedPhoneNumberVerificationForAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof initiatedPhoneNumberVerificationForAssessment>>>;
export type InitiatedPhoneNumberVerificationForAssessmentMutationBody = BodyType<InitiatePhoneNumberVerificationRequest> | undefined;
export type InitiatedPhoneNumberVerificationForAssessmentMutationError = ErrorType<unknown>;
export type InitiatedPhoneNumberVerificationForAssessmentMutationVariables = {
  assessmentId: string;
  data?: BodyType<InitiatePhoneNumberVerificationRequest>;
};

/**
 * @summary Initiates the verification request for phone number verification.
 */
export const useInitiatedPhoneNumberVerificationForAssessment = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getInitiatedPhoneNumberVerificationForAssessmentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getInitiatePhoneNumberVerificationForAssessmentResultsUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/auth/assessments/${assessmentId}/initiate-phone-verification-for-results`;
};

/**
 * @summary Initiates phone number verification for a person requesting to view their assessment results.
 */
export const initiatePhoneNumberVerificationForAssessmentResults = async (assessmentId: string, initiatePhoneNumberVerificationRequest?: InitiatePhoneNumberVerificationRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getInitiatePhoneNumberVerificationForAssessmentResultsUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(initiatePhoneNumberVerificationRequest)
  });
};
export const getInitiatePhoneNumberVerificationForAssessmentResultsMutationKey = () => ["initiatePhoneNumberVerificationForAssessmentResults"] as const;
export const getInitiatePhoneNumberVerificationForAssessmentResultsMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof initiatePhoneNumberVerificationForAssessmentResults>>, TError, InitiatePhoneNumberVerificationForAssessmentResultsMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof initiatePhoneNumberVerificationForAssessmentResults>>, TError, InitiatePhoneNumberVerificationForAssessmentResultsMutationVariables, TContext> => {
  const mutationKey = getInitiatePhoneNumberVerificationForAssessmentResultsMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatePhoneNumberVerificationForAssessmentResults>>, InitiatePhoneNumberVerificationForAssessmentResultsMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return initiatePhoneNumberVerificationForAssessmentResults(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type InitiatePhoneNumberVerificationForAssessmentResultsMutationResult = NonNullable<Awaited<ReturnType<typeof initiatePhoneNumberVerificationForAssessmentResults>>>;
export type InitiatePhoneNumberVerificationForAssessmentResultsMutationBody = BodyType<InitiatePhoneNumberVerificationRequest> | undefined;
export type InitiatePhoneNumberVerificationForAssessmentResultsMutationError = ErrorType<unknown>;
export type InitiatePhoneNumberVerificationForAssessmentResultsMutationVariables = {
  assessmentId: string;
  data?: BodyType<InitiatePhoneNumberVerificationRequest>;
};

/**
 * @summary Initiates phone number verification for a person requesting to view their assessment results.
 */
export const useInitiatePhoneNumberVerificationForAssessmentResults = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getInitiatePhoneNumberVerificationForAssessmentResultsMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getVerifyPhoneNumberForAssessmentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/auth/assessments/${assessmentId}/verify-phone-number`;
};

/**
 * @summary Verifies the phone number using the provided verification code.
 */
export const verifyPhoneNumberForAssessment = async (assessmentId: string, verifyPhoneNumberRequest?: VerifyPhoneNumberRequest, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayVerifyPhoneNumberResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<DisplayVerifyPhoneNumberResponse>(getVerifyPhoneNumberForAssessmentUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(verifyPhoneNumberRequest)
  });
};
export const getVerifyPhoneNumberForAssessmentMutationKey = () => ["verifyPhoneNumberForAssessment"] as const;
export const getVerifyPhoneNumberForAssessmentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneNumberForAssessment>>, TError, VerifyPhoneNumberForAssessmentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneNumberForAssessment>>, TError, VerifyPhoneNumberForAssessmentMutationVariables, TContext> => {
  const mutationKey = getVerifyPhoneNumberForAssessmentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPhoneNumberForAssessment>>, VerifyPhoneNumberForAssessmentMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return verifyPhoneNumberForAssessment(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type VerifyPhoneNumberForAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPhoneNumberForAssessment>>>;
export type VerifyPhoneNumberForAssessmentMutationBody = BodyType<VerifyPhoneNumberRequest> | undefined;
export type VerifyPhoneNumberForAssessmentMutationError = ErrorType<unknown>;
export type VerifyPhoneNumberForAssessmentMutationVariables = {
  assessmentId: string;
  data?: BodyType<VerifyPhoneNumberRequest>;
};

/**
 * @summary Verifies the phone number using the provided verification code.
 */
export const useVerifyPhoneNumberForAssessment = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getVerifyPhoneNumberForAssessmentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getVerifyPhoneNumberForAssessmentResultsUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/auth/assessments/${assessmentId}/verify-phone-number-for-results`;
};

/**
 * @summary Verifies phone number for an existing person who completed an assessment
 */
export const verifyPhoneNumberForAssessmentResults = async (assessmentId: string, verifyPhoneNumberForAssessmentResultsRequest?: VerifyPhoneNumberForAssessmentResultsRequest, options?: Parameters<typeof retrieveData>[1]): Promise<DisplayVerifyPhoneNumberForAssessmentResultsResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<DisplayVerifyPhoneNumberForAssessmentResultsResponse>(getVerifyPhoneNumberForAssessmentResultsUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(verifyPhoneNumberForAssessmentResultsRequest)
  });
};
export const getVerifyPhoneNumberForAssessmentResultsMutationKey = () => ["verifyPhoneNumberForAssessmentResults"] as const;
export const getVerifyPhoneNumberForAssessmentResultsMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneNumberForAssessmentResults>>, TError, VerifyPhoneNumberForAssessmentResultsMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneNumberForAssessmentResults>>, TError, VerifyPhoneNumberForAssessmentResultsMutationVariables, TContext> => {
  const mutationKey = getVerifyPhoneNumberForAssessmentResultsMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPhoneNumberForAssessmentResults>>, VerifyPhoneNumberForAssessmentResultsMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return verifyPhoneNumberForAssessmentResults(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type VerifyPhoneNumberForAssessmentResultsMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPhoneNumberForAssessmentResults>>>;
export type VerifyPhoneNumberForAssessmentResultsMutationBody = BodyType<VerifyPhoneNumberForAssessmentResultsRequest> | undefined;
export type VerifyPhoneNumberForAssessmentResultsMutationError = ErrorType<unknown>;
export type VerifyPhoneNumberForAssessmentResultsMutationVariables = {
  assessmentId: string;
  data?: BodyType<VerifyPhoneNumberForAssessmentResultsRequest>;
};

/**
 * @summary Verifies phone number for an existing person who completed an assessment
 */
export const useVerifyPhoneNumberForAssessmentResults = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getVerifyPhoneNumberForAssessmentResultsMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};